/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

import Icon3DMaterials from '../3DMaterials';
import Add from '../Add';
import Alert from '../Alert';
import Bell from '../Bell';
import React from 'react';
import {storiesOf} from '@storybook/react';

storiesOf('Icons/Workflow', module)
  .add(
    'icon: Add with sizes',
    () => renderIconSizes(Add, {'aria-label': 'Add'})
  )
  .add(
    'icon: Bell with sizes',
    () => renderIconSizes(Bell, {'aria-label': 'Bell'})
  )
  .add(
    'icon: _3DMaterials with sizes',

    () => renderIconSizes(Icon3DMaterials, {'aria-label': '3D Materials'})
  )
  .add(
    'icon: Alert negative',
    () => renderIconSizes(Alert, {'aria-label': 'Alert', color: 'negative'})
  )
  .add(
    'icon: Alert informative',
    () => renderIconSizes(Alert, {'aria-label': 'Alert', color: 'informative'})
  )
  .add(
    'icon: Alert positive',
    () => renderIconSizes(Alert, {'aria-label': 'Alert', color: 'positive'})
  )
  .add(
    'icon: Alert notice',
    () => renderIconSizes(Alert, {'aria-label': 'Alert', color: 'notice'})
  );

function renderIconSizes(Component, props) {
  let sizes = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL'];
  return (
    <div>
      {sizes.map(size => {
        return <Component margin="15px" size={size} {...props} />
      })}
    </div>
  )
}
